import { createContext, useState, ReactNode } from 'react';

// ----------------------------------------------------------------------

type ConfirmDialogContextProps =
{
    isOpen : boolean;
    text: string;
    confirmText: string;
    cancelText: string;
    confirmDialog: VoidFunction;
    cancelDailog: VoidFunction;
    confirmActionDialog: (params: ConfirmActionDialogParams)  => void;
};

type ConfirmActionDialogParams = { action: VoidFunction, text: string, cancel?: VoidFunction, confirmText?: string, cancelText?: string }

// ----------------------------------------------------------------------
const initialState : ConfirmDialogContextProps =
{
    isOpen : false,
    text: '',
    confirmText: '',
    cancelText: '',
    confirmDialog: () => {},
    cancelDailog: () => {},
    confirmActionDialog: (params: ConfirmActionDialogParams) => {},
};

const ConfirmDialogContext = createContext(initialState);

type ConfirmDialogContextProviderProps = {
    children: ReactNode;
  };

function ConfirmDialogContextProvider({ children }: ConfirmDialogContextProviderProps) {
    const[isOpen, setIsOpen] = useState(false);
    const[text, setText] = useState('');
    const[confirmText, setConfirmText] = useState('');
    const[cancelText, setCancelText] = useState('');
    const[confirmAction, setConfirmAction] = useState<VoidFunction>(() => {});
    const[cancelAction, setCancelAction] = useState<VoidFunction>(() => {});
    
    return (
        <ConfirmDialogContext.Provider value={
            { 
                isOpen: isOpen,
                text: text,
                confirmText,
                cancelText,
                confirmDialog: () => { 
                    confirmAction(); 
                    setConfirmAction(() => {}); 
                    setText(''); 
                    setIsOpen(false); 
                },
                cancelDailog: () => { 
                    if(!!cancelAction) cancelAction(); 
                    setIsOpen(false); 
                },
                confirmActionDialog: ({ action, text, cancel, confirmText, cancelText }: ConfirmActionDialogParams) => {
                    setIsOpen(true);
                    setText(text);
                    setConfirmText(confirmText ?? 'Ok');
                    setCancelText(cancelText ?? 'Cancel');
                    setConfirmAction(() => action);
                    setCancelAction(() => cancel ?? (() => {}));
                }
            }}
            >
            { children }
        </ConfirmDialogContext.Provider>
  );
}

export { ConfirmDialogContext, ConfirmDialogContextProvider };
